import React, { useEffect, useState } from "react";
import pic from "../assets/download (1).jpeg";
import logo from "../assets/app_logo.png";
import Avatar from "@mui/material/Avatar";
import { Helmet } from "react-helmet-async";
import Seo from "./Helmet";

const Sidebar = ({ video, videoId }) => {
  const updatingTheMeta = () => {
    console.log("videos", video);
    let ogMeta = document.createElement("meta");
    ogMeta.setAttribute("property", "og:title");
    ogMeta.setAttribute("content", "Your Dynamic OG Title Here");
    document.head.appendChild(ogMeta);

    let ogMeta1 = document.createElement("meta");
    ogMeta1.setAttribute("property", "og:description");
    ogMeta1.setAttribute(
      "content",
      "Your Dynamic OG Title Here and description"
    );
    document.head.appendChild(ogMeta1);

    let ogImage2 = document.createElement("meta");
    ogImage2.setAttribute("property", "og:image");
    ogImage2.setAttribute("content", "https://picsum.photos/200/300"); // Replace with your image URL
    document.head.appendChild(ogImage2);
  };
  updatingTheMeta();
  return (
    <>
      {/*<Seo Image={video.VidoeImage} videoId={videoId} />*/}
      <div
        className="hidden md:block col bg-black"
        style={{ borderRight: "1px solid rgba(251, 251, 251, 0.22)" }}
      >
        <div className="flex flex-col items-center mt-5">
          <div className="bg-black p-8 ">
            <Avatar
              alt="Remy Sharp"
              src={video.userImage}
              sx={{
                width: 280,
                height: 280,
                border: "1px solid rgba(93, 89, 86, 0.65)",
                boxShadow: "0 4px 10px rgba(125, 120, 120, 0.8)",
              }}
            />
          </div>
          <div>
            <p className="text-white text-cente font-sans text-lg">
              {video.name}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
export default Sidebar;
